import React from "react";
import { Link } from "react-router-dom";
import { forms } from "../components/Data";
import "../scss/forms.css";

const FormPortal = () => {
  return (
    <div className="form-portal">
      <div className="form-portal-header">
        <Link to="/" className="back-link">
          &larr; Back to Home
        </Link>
        <h1>Form Portal</h1>
        <p>Select a form to fill out</p>
      </div>

      <div className="forms-list">
        {forms.map((form) => (
          <Link
            to={`/test/forms/${form.id}`}
            key={form.id}
            className="form-card"
          >
            <div className="form-card-content">
              <h3>{form.name}</h3>
              <p>{form.description}</p>
              <span className="field-count">{form.fields.length} fields</span>
            </div>
            <div className="form-card-arrow">&rarr;</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FormPortal;
